export default __webpack_public_path__ + "static/media/grid.fa990d41.png";